import api from "../api/api";
import mixpanel from "../services/mixpanel";

export const accesstokenSetter = store => next => action => {
  // console.log(`------------------------${action.type}----------------------`);
  if (action.type === "SET_USER") {
    api.defaults.headers.common.Authorization = `Bearer ${action.profile.token}`;
    mixpanel.identify(action.profile.uid);
    mixpanel.people.set({
      $email: action.profile.email,
      $name: action.profile.name,
      picture: action.profile.picture,
    });
    mixpanel.people.set_once("$created", new Date());
  }
  next(action);
};



// WEBPACK FOOTER //
// ./src/middleware/accesstokenSetter.js